export enum MatchStatusEnum {
  SCHEDULED = "SCHEDULED",     // Match is scheduled but not started yet
  LIVE = "LIVE",               // Match is currently in progress
  COMPLETED = "COMPLETED",     // Match has finished
  CANCELLED = "CANCELLED",     // Match was cancelled before it started
  POSTPONED = "POSTPONED",     // Match was postponed to another date
  ABANDONED = "ABANDONED"      // Match was abandoned during play
}